import React, { useState } from "react";
import aboutVideo_img from "../../Images/HomePageImages/aboutvideoimg5.png";
import "../../Style/HomeAboutUs.css";
import { FaRegCirclePlay } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import Videomodel from "./Videomodel";

const HomeAboutUs = () => {
  const navigation = useNavigate();
  const [show, setShow] = useState(false);
  return (
    <>
      <div className="HomeAboutUs">
        <div className="container-xxl p-0">
          <div className="row">
            <div className="col-lg-6">
              <div
                className="video_card d-flex justify-content-end align-items-end"
                onClick={() => setShow(true)}
              >
                <img src={aboutVideo_img} alt="img" className="video_img" />
                {/* <img src={videobgtopimg} alt="img" /> */}
                <div className="video_icon">
                  <FaRegCirclePlay />
                </div>
              </div>
            </div>
            <div className="col-lg-6 mt-lg-0 mt-4">
              <div className="about_details">
                <span className="fw-bold">About Us</span>
                <h3 className=" fw-medium my-2">MEET DI HENNEBERRY</h3>
                <p>
                   Henneberry Property Group, owned by Di Henneberry, offers a high-quality property service throughout Sydney and New South Wales, backed by extensive industry experience and a passion for tailored service.<br/>
                    Awarded and respected for her 20-year career in real estate, Di has chosen to work with Sydney’s elite property organisations. This has allowed Di to refine her extensive knowledge and implement a focused and detail-oriented service with all her clients. Whether you are looking for Sydney property to buy and to invest in, property to sell, or would like a property managed, Di has designed a service around your needs.<br/>
                    Di's service is thoroughly considered, planned and executed with her clients in mind. This can involve everything from a thorough property viewing and analysis, and considering the potential for growth from an investment perspective in the long term. Di looks at the often overlooked, yet important small features of a property, that can impact the value and its future returns as well as the lifestyle of its occupants.
                </p>
                {/* <div className="row items  d-flex">
                <div className="col-md-6">
                  <div className=" text d-flex align-items-center">
                    <span></span>
                    <p>Lorem Ipsum is simply</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="text d-flex align-items-center">
                    <span></span>
                    <p>Lorem Ipsum is simply</p>
                  </div>
                </div>
                <div className="col-md-6 d-flex ">
                  <div className="text  d-flex align-items-center">
                    <span></span>
                    <p>Lorem Ipsum is simply</p>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="text  d-flex align-items-center">
                    <span></span>
                    <p>Lorem Ipsum is simply</p>
                  </div>
                </div>
              </div> */}
                <Button onClick={() => navigation("/about")}>
                  Read More <FaAngleRight />
                </Button>
              </div>
            </div>
            <Videomodel show={show} setShow={setShow} />
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeAboutUs;
